import { Button, Container, Paper, Stack, Text, Title } from '@mantine/core'
import { IconCircleCheck } from '@tabler/icons-react'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/register-complete')({
  component: RegisterCompletePage,
})

function RegisterCompletePage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        position: 'relative',
        background: 'linear-gradient(90deg, #ff6600 10%, #ff8800 100%)',
      }}
    >
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Container size="100%" px={8} style={{ maxWidth: 1000, width: '100%', margin: '0 auto' }}>
          <Paper
            withBorder
            shadow="md"
            p={30}
            mt={80}
            mb={120}
            radius="md"
            w="100%"
            style={{ maxWidth: 800, width: '100%', margin: '0 auto' }}
          >
            <Stack align="center" justify="center" style={{ minHeight: 450, width: '100%' }}>
              <div
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  backgroundColor: '#d1fae5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 16,
                }}
              >
                <IconCircleCheck size={48} color="#10b981" />
              </div>
              <Title order={2} style={{ fontWeight: 600, color: '#222', marginTop: 16, marginBottom: 8 }}>
                Your account is set up!
              </Title>
              <Text c="dimmed" mb={32} style={{ maxWidth: 450, textAlign: 'center' }}>
                Welcome to Carma.
              </Text>
              <Button component="a" href="/" size="md" style={{ minWidth: 240, fontWeight: 600, fontSize: 18 }}>
                Sign in
              </Button>
            </Stack>
          </Paper>
        </Container>
      </div>
    </div>
  )
}
